import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import CoreuiVue from '@coreui/vue';
import StoryblokVue from 'storyblok-vue'
import CompositionApi from '@vue/composition-api'
import RichtextRenderer from '@marvr/storyblok-rich-text-vue-renderer'
import Page from '@/components/StoryblokPage.vue'
import Headline from '@/components/StoryblokHeadline.vue'
import Subheading from '@/components/StoryblokSubheading.vue'
import Note from '@/components/StoryblokNote.vue'
import Crosslink from '@/components/StoryblokLink.vue'
import Picture from '@/components/StoryblokPicture.vue'
import Spacer from '@/components/StoryblokSpacer.vue'
import Richtext from '@/components/StoryblokRichtext.vue'
import News from '@/components/StoryblokNews.vue'
import store from '@/store';
import router from '@/router';
import { iconsSet as icons } from './assets/icons/icons.js'
import {func} from '@/func'

Vue.use(CoreuiVue);
Vue.use(StoryblokVue);
Vue.use(CompositionApi);
Vue.use(RichtextRenderer);

Vue.component('page', Page);
Vue.component('headline', Headline);
Vue.component('subheading', Subheading);
Vue.component('note', Note);
Vue.component('pic', Picture);
Vue.component('crosslink', Crosslink);
Vue.component('spacer', Spacer);
Vue.component('richtext', Richtext);
Vue.component('news', News);

Vue.prototype.$func = func;
Vue.config.productionTip = false;

new Vue({
    store,
    router,
    icons,
    render: h => h(App),
}).$mount('#app')
